import clamp from 'clamp-js';

$(function () {

  $('#sort_posts').on('change', function () {
    let order = {
      order_by: $(this).val()
    };

    window.history.pushState({}, '', '?' + $.param(order));
    $.ajax({
      method: 'GET',
      url: 'blog',
      data: order,
      dataType: 'script'
    })
  });

  let postsContainer = document.querySelector('#blog-posts');

  if (postsContainer) {
    postsContainer.addEventListener('DOMSubtreeModified', function () {
      setTimeout(() => {
        stringClamp();
      })
    }, false);

  };

  function stringClamp() {
    document.querySelectorAll('.short-description').forEach(el => {
      clamp(el, {clamp: 3});
    });

    // document.querySelectorAll('.ad-model').forEach(el => {
    //   clamp(el, {clamp: 2});
    // });
  };

  stringClamp();

  window.onresize = () => {
    stringClamp();
  }
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/blog_page.js